export const SecuredByFooter = () => {
  return (
    <div className="secured-by-footer">
      Secured by <b>MetaKeep</b>
      <sup>TM</sup>
    </div>
  );
};
